// import React, { useEffect } from "react";
// import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';

// const HelpModal = ({open,handleClose}) => {

//     return (
//         <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
//             <DialogTitle>
//                 {/* Tutorial */}
//                 Need Help? We’re Here for You!
//                 <IconButton
//                     aria-label="close"
//                     onClick={handleClose}
//                     sx={{
//                         position: 'absolute',
//                         right: 5,
//                         top: 5,
//                         color: (theme) => theme.palette.grey[500],
//                     }}
//                 >
//                     <CloseIcon />
//                 </IconButton>
//             </DialogTitle>
//             <DialogContent dividers>
//                 <div style={{ width: '100%',  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                     {/* <video
//                         width="100%"
//                         height="100%"
//                         controls
//                         src="https://webbie.s3.af-south-1.amazonaws.com/Sample_files_webbieshop/VID-20240703-WA0000Tutorialvideo.mp4"
//                     > */}
//                         Setting up your online store should be simple—and we’re here to make sure it is. Whether you're just getting started or need help managing your products, payments, or shipping, our team is ready to support you every step of the way.
//                         📧 Email us at: admin@webbieshop.com
//                         And we promise to get back to you within 12 hours—because your time matters.
//                     {/* </video> */}
//                 </div>
//             </DialogContent>
//         </Dialog>
//     );
// };

// export default HelpModal;


import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const HelpModal = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontSize: "1.3rem",
          padding: "24px 24px 8px",
          position: "relative",
        }}
      >
        Need Help? We’re Here for You!
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Box sx={{ textAlign: "left", width: "100%" }}>
          <Typography variant="body1" sx={{ fontSize: "0.9rem", mb: 2 }}>
            Setting up your online store should be simple — and we’re here to make sure it is. Whether you're just getting started or need help managing your products, payments, or shipping, our team is ready to support you every step of the way. 💡
          </Typography>

          <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
            📧 Email us at:{" "}
            <a
              href="mailto:hello@webbieshop.com"
              style={{
                color: "#1976d2",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              hello@webbieshop.com
            </a>
          </Typography>

          <Typography variant="caption" color="text.secondary">
            We promise to get back to you within 12 hours — because your time matters.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default HelpModal;
